import * as Api from '../../api';
import Utils from '../../untils';
import Vue from 'vue'
const state = {
};

const getters = {
};

const mutations = {
};
const actions = {
  getUserUConnectSubscription ({state, rootState}, {pat, callback}) {
    let obj = {
      action: `/oa/u-connect/user/subscription`,

    };
    Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
    Api.requestget(obj).then((resp) => {
      if (callback) {
        callback(resp, 'getUserUConnectSubscriptionCallback')
      }
    })
  },
  getChannelPartnerUConnectSubscriptionById ({state, rootState}, {params, callback}) {
    let obj = {
      action: `/oa/u-connect/user/subscription/${params.cpId}`,


    };
    Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
    Api.requestget(obj).then((resp) => {
      if (callback) {
        callback(resp, 'getChannelPartnerUConnectSubscriptionCallback')
      }
    })
  },
  getAllUConnectPackages ({state, rootState}, {pat, callback}) {
    let obj = {
      action: `/oa/u-connect/stnd/packages`,
    };
    Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
    Api.requestget(obj).then((resp) => {
      if (callback) {
        callback(resp, 'getAllUConnectPackagesCallback')
      }
    })
  },
  cancelUConnectSubscription ({state}, {params, callback}) {
    console.log("pat", params);
    let obj = {
      action: `/oa/u-connect/user/subscription/cancel`,
      ...params
    };
    console.log(obj);
    Vue.http.headers.common = {webType:'store',token:state.token?state.token:Utils.loadLocal2('token')}
    Api.requestbody(obj).then((resp) => {
      if (callback) {
        callback(resp, 'cancelUConnectSubscriptionCallback')
      }
    })
  },
  changePackage ({state}, {params, callback}) {
    console.log("pat", params);
    let obj = {
      action: `/oa/u-connect/subscription/update`,
      ...params
    };
    console.log(obj);
    Vue.http.headers.common = {webType:'store',token:state.token?state.token:Utils.loadLocal2('token')}
    Api.requestbody(obj).then((resp) => {
      if (callback) {
        callback(resp, 'changePackageCallback')
      }
    })
  },
  cancelPackage ({state}, {params, callback}) {
    console.log("pat", params);
    let obj = {
      action: `/oa/u-connect/subscription/cancel`,
      ...params
    };
    console.log(obj);
    Vue.http.headers.common = {webType:'store',token:state.token?state.token:Utils.loadLocal2('token')}
    Api.requestbody(obj).then((resp) => {
      if (callback) {
        callback(resp, 'cancelPackageCallback')
      }
    })
  },
  getChannelPartnerDetails ({state, rootState}, {pat, callback}) {
    let obj = {
      action: `/oa/u-connect/user/details`,
    };
    Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
    Api.requestget(obj).then((resp) => {
      if (callback) {
        callback(resp, 'getChannelPartnerDetailsCallback')
      }
    })
  },
  updateChannelPartnerDetails ({state, rootState}, {params, callback}) {
    console.log("pat", params);
    let obj = {
      action: `/oa/u-connect/user/details/update`,
      ...params
    };
    console.log(obj);
    Vue.http.headers.common = {webType:'store',token:state.token?state.token:Utils.loadLocal2('token')}
    Api.requestbody(obj).then((resp) => {
      if (callback) {
        callback(resp, 'updateChannelPartnerDetailsCallback')
      }
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/uConnect.js